import { TryModePresets } from './try-mode-affordances.js';
import type { TryMode } from './try-mode-tabs.js';

export interface TryCreatePresetElements {
  textarea: HTMLTextAreaElement | null;
  helperText: HTMLParagraphElement | null;
  modeHint: HTMLParagraphElement | null;
  createModule: HTMLDivElement | null;
  inputContainer: HTMLDivElement | null;
  uploadBtn: HTMLButtonElement | null;
}

export interface ApplyTryCreatePresetOptions {
  focus: boolean;
}

export interface AppliedTryCreatePreset {
  helper: string;
}

export function applyTryCreatePresetDom(
  elements: TryCreatePresetElements,
  mode: TryMode,
  opts: ApplyTryCreatePresetOptions = { focus: false }
): AppliedTryCreatePreset {
  const preset = TryModePresets[mode];

  if (elements.textarea) {
    elements.textarea.placeholder = preset.placeholder;
  }
  if (elements.helperText) {
    elements.helperText.textContent = preset.helper;
  }
  if (elements.modeHint) {
    elements.modeHint.textContent = preset.hint;
    elements.modeHint.classList.toggle('visible', preset.hint.length > 0);
  }

  updateTextareaDescription(elements);

  if (elements.createModule) {
    elements.createModule.setAttribute('data-create-mode', mode);
    elements.createModule.setAttribute(
      'data-file-controls-primary',
      String(preset.fileControlsPrimary)
    );
  }
  if (elements.inputContainer) {
    elements.inputContainer.setAttribute('data-create-mode', mode);
  }

  if (opts.focus) {
    focusPresetTarget(elements, preset.focusTarget);
  }

  return { helper: preset.helper };
}

function updateTextareaDescription(elements: TryCreatePresetElements): void {
  if (!elements.textarea) return;

  const describedByIds: string[] = [];
  if (elements.helperText) {
    describedByIds.push(elements.helperText.id || 'try-helper');
  }
  if (elements.modeHint?.textContent && elements.modeHint.textContent.length > 0) {
    describedByIds.push(elements.modeHint.id || 'try-mode-hint');
  }

  if (describedByIds.length > 0) {
    elements.textarea.setAttribute('aria-describedby', describedByIds.join(' '));
  } else {
    elements.textarea.removeAttribute('aria-describedby');
  }
}

function focusPresetTarget(
  elements: TryCreatePresetElements,
  focusTarget: 'textarea' | 'upload' | null
): void {
  if (focusTarget === 'textarea') {
    elements.textarea?.focus();
  } else if (focusTarget === 'upload') {
    elements.uploadBtn?.focus();
  }
}
